function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 23,
  cy: 27.4,
  r: 21,
  stroke: "#F88A2B",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 23,
  cy: 27.4,
  r: 4.5,
  stroke: "#F88A2B",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 21.8999,
  y: 10.9,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  fill: "#F88A2B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 21.8999,
  y: 36.2,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  fill: "#F88A2B"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 39.5,
  y: 26.3,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  transform: "rotate(90 39.5 26.3)",
  fill: "#F88A2B"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 14.2002,
  y: 26.3,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  transform: "rotate(90 14.2002 26.3)",
  fill: "#F88A2B"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 35.4448,
  y: 38.2895,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  transform: "rotate(135 35.4448 38.2895)",
  fill: "#F88A2B"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 17.5552,
  y: 20.3997,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  transform: "rotate(135 17.5552 20.3997)",
  fill: "#F88A2B"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 11.9785,
  y: 39.728,
  width: 2.2,
  height: 7.7,
  rx: 1.1,
  transform: "rotate(-134.39 11.9785 39.728)",
  fill: "#F88A2B"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.3999 7.6V3C16.3999 1.89543 17.2953 1 18.3999 1H27.5999C28.7045 1 29.5999 1.89543 29.5999 3V7.6",
  stroke: "#F88A2B",
  strokeWidth: 2
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.98918 15.5116L3.51431 13.0368C2.73326 12.2557 2.73326 10.9894 3.51431 10.2083L5.24091 8.48173C6.02196 7.70069 7.28829 7.70069 8.06933 8.48173L10.5442 10.9566",
  stroke: "#F88A2B",
  strokeWidth: 2
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.1002 10.9566L37.575 8.48173C38.3561 7.70069 39.6224 7.70069 40.4035 8.48173L42.1301 10.2083C42.9111 10.9894 42.9111 12.2557 42.1301 13.0368L39.6552 15.5116",
  stroke: "#F88A2B",
  strokeWidth: 2
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.8149 21.9599L34.562 15.0263C35.3761 14.5011 36.3174 15.485 35.7567 16.2751L28.4403 26.5846C28.0858 24.1995 26.2001 22.314 23.8149 21.9599Z",
  fill: "#F88A2B"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "media/result-time-icon.c0b6fe79.svg";
export { SvgComponent as ReactComponent };